import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EChallanTrafficFines from "./component";

const mapStateToProps = ({
    eChallan: { stateName, cmsContent: { trafficFines = {} } }
}) => ({
    stateName,
    trafficFines
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EChallanTrafficFines);
